export const getMenuActiveKey = (collapsed: boolean) => {
  return collapsed ? '0' : '';
};
